<template>
    <main>
 
        <TableToolbar :buttons="['filter', 'info']" :id="'indicesToolbar'" :isFilterShown="showFilter"
            @cancelFilter="showFilter = false;" @toggleFilter="showFilter = !showFilter">
            <template #toolbarFilter="{ filterButtonRef }">
                <keep-alive>
                    <ListFilter v-if="showFilter" @cancel="showFilter = false" ref="filterPanel"
                        @applyFilter="applyFilter" :filterButtonRef="filterButtonRef"
                        :filterKeys="['marketCap', 'sector']" :defaultSelect="filters" />
                </keep-alive>
            </template>


            <template #main>
                <div>
                    <div id="filterPanel">
                        <tabs id="filterTabs" @tabClick="setTab" class="hideMobile" :transparent="true"
                            :no-border="true" :round="true" :tabs="categoryTabs" :active-tab="tab" />
                    </div>
                </div>

            </template>
        </TableToolbar>
        <SymbolsList :isFloating="false" :height-elements="['indicesToolbar']" :endpoint="finalEndPoint" :key="finalEndPoint" />
    </main>
</template>

<script>

import BigLoader from "../components/ui/BigLoader";
import Tabs from "../components/ui/Tabs";
import ListFilter from "../components/filter/ListFilter";
import TableToolbar from "../components/ui/TableToolbar";
import SymbolsList from "./SymbolsList";

export default {
    name: "IndexList",
    components: {
        TableToolbar,
        ListFilter,
        Tabs, BigLoader, SymbolsList
    },
    props: ['prices', 'isMini'],

    data() {
        return {
            filters: {},
            showFilter: false,
            tab: 'sp500',
            categoryTabs: [{
                value: 'sp500',
                label: 'S&P500'
            }, {
                value: 'nasdaq100',
                label: 'Nasdaq100'
            }, {
                value: 'russell2000',
                label: 'Russell2000'
            }],

        }
    },
    computed: {
        finalEndPoint() {


            let endpointUrl = `/symbols/filter?index=${this.tab}`;
            if (this.filters.sector?.length > 0) {
                endpointUrl += `&sector=${this.filters.sector.map(sector => encodeURIComponent(sector)).join(',')}`;
            }
            if (this.filters.marketCap?.length > 0) {
                endpointUrl += `&marketCap=${this.filters.marketCap.map(marketCap => encodeURIComponent(marketCap)).join(',')}`;
            }

            return endpointUrl;
        },
    },
    methods: {

        async applyFilter(filters) {

            this.filters = filters;

            if (filters.index.length > 0) {

                this.selectedIndex = filters.index.map(index => {

                    if (index === 'sp500') return 'S&P 500';
                    if (index === 'nasdaq100') return 'NASDAQ 100';
                    if (index === 'russell2000') return 'Russell 2000';
                })
            }

            if (window.innerWidth <= 768) {

                this.showFilter = false;
            }
        },
        setTab(tab) {

            this.tab = tab;
        },
    },

}
</script>

<style scoped lang="scss">
@import "../assets/style/vars";
@import "../assets/style/calendar";
@import "../assets/style/general";

.tab {
    width: 33%;

}

.symbolRow {
    border-bottom: 1px solid var(--notficationBorderColor);
    padding: $smallGap;

    &:last-of-type {
        border-bottom: none;
    }
}

h2 {
    margin: 0 $smallGap $smallGap;
    padding: 0;
}

h3 {
    color: var(--textColor);
    margin: 0;
    padding: 5px 10px;

}

#topTable {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

    section {
        width: 100%;
    }
}

.symbolTd {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;

    a {
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
}

.addRemoveSymbol {
    flex: 0 0 55px !important;
    width: 45px;
    margin-left: auto;

    &[dir="rtl"] {
        margin-left: unset;
        margin-right: auto;
    }

    i {
        display: none;
    }

    @media(max-width: 660px) {

        flex: 0 0 30px !important;
        width: 30px;
        height: 20px;
        box-sizing: border-box;
        justify-content: center;
        align-items: center;

        i {
            display: block;
        }

        span {
            //display: none;
        }
    }
}

.tabs.round {
    z-index: 2;
    padding: 3px 5px !important;
    margin: 0 !important;
}

#filterPanel {
    padding: 0;
    display: flex;
    align-items: center;
    gap: 1rem;

    @media(max-width: 768px) {
        margin-top: .5rem;
    }

    #flexBlock {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    @media(max-width: 660px) {}

}

#topBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--notficationBorderColor) !important;

    @media(max-width: 660px) {
        display: block;
    }
}

.tabs:not(.round) {
    position: unset;
}


.selectedIndex {
    text-align: center;
    background: var(--lightYellowOpacity);
    border: 1px solid var(--lightYellow);
    padding: 2px 7px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    color: var(--textColor);
    margin: 0 .5rem 0 0;

    @media(max-width: 768px) {
        margin: .5rem 0;
    }
}
</style>
